import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IClub } from 'src/app/modules/clubs/model';

@Component({
  selector: 'app-business-club-item',
  templateUrl: './business-club-item.component.html',
  styleUrls: ['./business-club-item.component.scss']
})
export class BusinessClubItemComponent {
  @Input('club') private readonly _club: IClub;

  @Output() joinEvent: EventEmitter<any> = new EventEmitter();

  get club() {
    return this._club;
  }
}
